export enum ReceiptValidationError {
  UNSAVED_CHANGES = 'UNSAVED_CHANGES',
  MISSING_CASH_LINK = 'MISSING_CASH_LINK',
  MISSING_IMAGE = 'MISSING_IMAGE',
  MISSING_RESIDENT = 'MISSING_RESIDENT',
  MISSING_TYPE = 'MISSING_TYPE',
  MISSING_DATE = 'MISSING_DATE',
  MISSING_AMOUNT = 'MISSING_AMOUNT',
  MISSING_SERVICE_PROVIDER = 'MISSING_SERVICE_PROVIDER',
  PLIANT_AMOUNT_MISMATCH = 'PLIANT_AMOUNT_MISMATCH',
}

export enum ReceiptBatchValidationError {
  UNSAVED_CHANGES = 'UNSAVED_CHANGES',
  MISSING_CASH_LINK = 'MISSING_CASH_LINK',
  MISSING_BATCH_IMAGE = 'MISSING_BATCH_IMAGE',
  MISSING_BATCH_TITLE = 'MISSING_BATCH_TITLE',
  MISSING_BATCH_DATE = 'MISSING_BATCH_DATE',
  MISSING_RECEIPT_RESIDENT = 'MISSING_RECEIPT_RESIDENT',
  MISSING_RECEIPT_TYPE = 'MISSING_RECEIPT_TYPE',
  MISSING_RECEIPT_DATE = 'MISSING_RECEIPT_DATE',
  MISSING_RECEIPT_AMOUNT = 'MISSING_RECEIPT_AMOUNT',
  MISSING_RECEIPT_IMAGE = 'MISSING_RECEIPT_IMAGE',
  MISSING_SERVICE_PROVIDER = 'MISSING_SERVICE_PROVIDER',
  NO_RECEIPTS_IN_BATCH = 'NO_RECEIPTS_IN_BATCH',
  PLIANT_AMOUNT_MISMATCH = 'PLIANT_AMOUNT_MISMATCH',
}

export interface ValidationError<
  T = ReceiptValidationError | ReceiptBatchValidationError
> {
  type: T;
  translationKey: string;
  details: Record<string, unknown> | undefined;
}

export interface ReceiptValidationContext {
  formValues: {
    residentId: string | undefined;
    transactionType: string | undefined;
    date: string | Date | undefined;
    amount: number | undefined;
    additionalFeeAmount: number | undefined;
    includedFeeAmount: number | undefined;
    serviceProvider: string | undefined;
    serviceProviderRequired: boolean | undefined;
    receiptImageIds: string[] | undefined;
    cashTransactionGroupId: string | undefined;
    earnings: boolean;
  };
  isDirty: boolean;
  cashLinkFeatureEnabled?: boolean;
  mandatoryCashLinkRequired: boolean;
  receiptImagesRequired: boolean;
  pliantTransactionAmount?: number;
}

export interface BatchReceiptDetails {
  residentId: string | undefined;
  amount: number | undefined;
  individualDate: string | Date | undefined;
  receiptImageIds: string[] | undefined;
  notes: string | undefined;
}

export interface ReceiptBatchValidationContext {
  batchValues: {
    title: string | undefined;
    receiptDate: string | Date | undefined;
    receiptType: string | undefined;
    serviceProvider: string | undefined;
    serviceProviderRequired: boolean;
    batchImageIds: string[] | undefined;
    cashTransactionGroupId: string | undefined;
    earnings: boolean;
  };
  receipts: BatchReceiptDetails[];
  isDirty: boolean;
  cashLinkFeatureEnabled: boolean;
  mandatoryCashLinkRequired: boolean;
  receiptImagesRequired: boolean;
  useIndividualDates: boolean;
  autoGenerateReceipts: boolean;
  pliantTransactionAmount?: number;
}
